import { useEffect, useState } from 'react';

const DEVELOPER_MODE_KEY = 'erozion.developer_mode';
const DEVELOPER_MODE_EVENT = 'erozion:developer-mode-changed';

export const isDeveloperModeEnabled = () => {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(DEVELOPER_MODE_KEY) === 'true';
};

export const setDeveloperModeEnabled = (enabled: boolean) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(DEVELOPER_MODE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent(DEVELOPER_MODE_EVENT, { detail: { enabled } }));
};

export const useDeveloperMode = () => {
  const [enabled, setEnabled] = useState(isDeveloperModeEnabled);

  useEffect(() => {
    const syncDeveloperMode = () => setEnabled(isDeveloperModeEnabled());

    window.addEventListener('storage', syncDeveloperMode);
    window.addEventListener(DEVELOPER_MODE_EVENT, syncDeveloperMode);
    return () => {
      window.removeEventListener('storage', syncDeveloperMode);
      window.removeEventListener(DEVELOPER_MODE_EVENT, syncDeveloperMode);
    };
  }, []);

  return enabled;
};
